import { useState } from "react";
import { Treatment } from "@/services/backend/vbs/treatments/types/treatment";
import {
  updateVbsTreatmentCache,
  useVbsTreatmentResetReferenceNumberMutation,
  useVbsTreatmentPatchMutation,
} from "@/services/backend/vbs/treatments/api/treatment-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { Card, CardContent } from "@/shared/components/ui/card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * TreatmentReferenceNumberCard edits the reference number of a treatment.
 * Treatments owned by another document are not numbered; nothing is
 * rendered for them.
 */
export function TreatmentReferenceNumberCard({
  treatment,
  disabled = false,
}: {
  treatment: Treatment;
  disabled?: boolean;
}) {
  const patchReferenceNumber = useVbsTreatmentPatchMutation();
  const resetReferenceNumber = useVbsTreatmentResetReferenceNumberMutation();
  // Decided once on mount: an optimistically cleared input must not hide the
  // field of a numbered treatment.
  const [numbered] = useState(
    () => treatment.referenceNumber !== "" || !treatment.ownerId,
  );

  if (!numbered) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <ReferenceNumberField
          data={treatment}
          updateCache={updateVbsTreatmentCache}
          patchMutation={patchReferenceNumber}
          resetMutation={resetReferenceNumber}
          disabled={disabled || isImmutable(treatment)}
        />
      </CardContent>
    </Card>
  );
}
